import { QuizConfig } from '../../types/quiz';

const sleepHealthQuiz: QuizConfig = {
  id: 'sleep-health',
  title: '수면 건강 테스트',
  shortTitle: '수면 건강',
  description: '10가지 질문으로 나의 수면 건강 상태를 확인해보세요',
  icon: '😴',
  gradient: ['#E8EAF6', '#3F51B5'],
  headerColor: '#C5CAE9',
  questions: [
    { id: 1, description: '매일 같은 시간에 자고 일어납니까?', yesScore: 4, noScore: -3 },
    { id: 2, description: '잠자리에 누운 후 30분 이내에 잠이 듭니까?', yesScore: 4, noScore: -3 },
    { id: 3, description: '밤에 2회 이상 깹니까?', yesScore: -3, noScore: 4 },
    { id: 4, description: '코골이가 심하거나 수면 무호흡 증상이 있습니까?', yesScore: -4, noScore: 3 },
    { id: 5, description: '오후 2시 이후에도 카페인(커피, 녹차, 에너지드링크)을 마십니까?', yesScore: -3, noScore: 3 },
    { id: 6, description: '잠자리에서 스마트폰을 30분 이상 사용합니까?', yesScore: -3, noScore: 4 },
    { id: 7, description: '아침에 일어났을 때 개운하다고 느낍니까?', yesScore: 4, noScore: -3 },
    { id: 8, description: '낮에 졸음이 와서 일상에 지장을 받습니까?', yesScore: -3, noScore: 4 },
    { id: 9, description: '취침 전 과식하거나 야식을 먹습니까?', yesScore: -3, noScore: 3 },
    { id: 10, description: '침실 환경(온도, 소음, 빛)이 수면에 적합합니까?', yesScore: 4, noScore: -3 },
  ],
  explanations: [
    { good: '규칙적인 수면 스케줄은 체내 시계(일주기 리듬)를 안정시킵니다!', bad: '불규칙한 수면은 만성 피로와 면역력 저하를 유발합니다.' },
    { good: '빠른 입면은 건강한 수면 패턴의 지표입니다!', bad: '입면 지연은 불면증의 초기 증상일 수 있습니다.' },
    { good: '중간 각성 없이 숙면하고 있어요!', bad: '빈번한 야간 각성은 수면의 질을 크게 떨어뜨립니다.' },
    { good: '호흡이 안정적이라면 수면의 질이 높습니다!', bad: '수면 무호흡증은 심혈관 질환 위험을 3배 높이며, 반드시 치료가 필요합니다.' },
    { good: '카페인을 적절히 관리하고 있어요!', bad: '카페인의 반감기는 약 6시간으로, 오후 섭취는 수면을 방해합니다.' },
    { good: '블루라이트 노출을 줄이면 멜라토닌 분비가 원활해집니다!', bad: '취침 전 스마트폰 사용은 멜라토닌 분비를 억제합니다.' },
    { good: '상쾌한 아침은 양질의 수면을 나타냅니다!', bad: '아침 피로감은 수면의 질이 낮다는 신호입니다.' },
    { good: '낮에 졸리지 않다면 충분한 수면을 취하고 있어요!', bad: '주간 졸음증은 수면 부족이나 수면 장애의 증상입니다.' },
    { good: '취침 전 식사 조절은 소화계와 수면 모두에 좋습니다!', bad: '야식은 소화 활동으로 인해 깊은 수면을 방해합니다.' },
    { good: '좋은 수면 환경은 수면의 질을 크게 높입니다!', bad: '부적절한 수면 환경은 수면의 질을 30% 이상 떨어뜨릴 수 있습니다.' },
  ],
  healthTips: [
    { question: '수면 규칙성', tip: '주말에도 같은 시간에 일어나세요. 기상 시간 고정이 수면 리듬 개선의 핵심입니다.', icon: '⏰' },
    { question: '입면 시간', tip: '4-7-8 호흡법(4초 들숨, 7초 정지, 8초 날숨)을 시도해보세요.', icon: '🌙' },
    { question: '야간 각성', tip: '잠에서 깨면 시계를 보지 마세요. 불안감이 각성을 악화시킵니다.', icon: '🌃' },
    { question: '코골이/무호흡', tip: '수면 무호흡이 의심되면 반드시 수면다원검사를 받으세요.', icon: '🏥' },
    { question: '카페인', tip: '오후 2시 이후에는 디카페인으로 전환하세요. 초콜릿에도 카페인이 있어요!', icon: '☕' },
    { question: '스마트폰', tip: '취침 1시간 전부터 나이트 모드를 켜거나 독서로 전환하세요.', icon: '📵' },
    { question: '기상 컨디션', tip: '커튼을 열어 아침 햇빛을 받으세요. 15분 이상의 광노출이 각성에 도움됩니다.', icon: '🌅' },
    { question: '주간 졸음', tip: '낮잠은 20분 이내로 제한하고, 오후 3시 이전에만 자세요.', icon: '💤' },
    { question: '야식', tip: '저녁 식사는 취침 3시간 전까지 마치세요. 배고프면 따뜻한 우유 한 잔이 좋습니다.', icon: '🥛' },
    { question: '수면 환경', tip: '침실 온도 18-20°C, 암막 커튼, 백색 소음기를 활용해보세요.', icon: '🛏️' },
  ],
  categories: [
    { name: '수면 패턴', color: '#3F51B5', indices: [0, 1, 2] },
    { name: '수면 장애', color: '#f44336', indices: [3, 7] },
    { name: '수면 위생', color: '#FF9800', indices: [4, 5, 8] },
    { name: '수면 환경/질', color: '#4CAF50', indices: [6, 9] },
  ],
  resultTiers: [
    { maxScore: -8, title: '좀비 모드', emoji: '🧟' },
    { maxScore: 0, title: '수면 빚쟁이', emoji: '😵' },
    { maxScore: 10, title: '그냥저냥 잠꾸러기', emoji: '😪' },
    { maxScore: 20, title: '꿀잠 달인', emoji: '😴' },
    { maxScore: Infinity, title: '잠의 신', emoji: '👼' },
  ],
  baseValue: 50,
  resultUnit: '점',
  resultPrefix: '수면 건강 ',
  resultSuffix: '',
  percentile: { mean: 8, sd: 10 },
  seo: {
    title: '수면 건강 테스트 - 나의 수면 질은?',
    description: '10가지 질문으로 수면 건강을 자가진단해보세요. 수면 패턴, 수면 위생, 수면 환경을 종합 평가합니다.',
  },
};

export default sleepHealthQuiz;
